import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {LegalService} from '../../../networking/services/legal/legal.service';
@Injectable({
  providedIn: 'root',
})
export class LegalManager {
  isBrowser;
  constructor(private legalService: LegalService,) { 
    
    }

  getLegalInfo(params?): Observable<any> {
    const page =  params; 
    return this.legalService.get()
    .pipe(map(response => response[page]));
  }
}
